<template>
  <div class="member-label">会員</div>
</template>

<script>
/**
 * テキストラベル
 */
export default {
  name: 'MemberLabel',
}
</script>

<style lang="postcss" scoped>
.member-label {
  background-color: var(--white);
  border: solid 1px #5147cc;
  box-sizing: border-box;
  color: #5147cc;
  font-size: 10px;
  height: 16px;
  line-height: 1.2;
  min-width: 28px;
  text-align: center;
}
</style>
